import { useContext } from "react";
import { MyContext } from "../Context/ContextProvider";
import colors from "../colors.json";

const UseData = () => {
  return useContext(MyContext);
};

export const useTheme = () => {
  // Get current theme from body class
  const bodyClass = document.querySelector("body")?.className || "yellow";
  const themeColor = colors.find(c => c.color === bodyClass)?.hex || "#ffb400";
  return themeColor;
};

export default UseData;
